// Copyright (c) StrangeBee 2023

import React, { ReactElement } from 'react';
import { useLocalMessage } from '@Helpers/';
import { Link } from 'react-router-dom';
import RouteBuilder from '@Services/RouteBuilder';
import { OrganisationOutput } from 'thehive-sdk';
import { Avatar } from 'antd';
import THTag from '@Atoms/THTag/THTag';
import { PatternType } from '@Constants/patternsRoute';
import { PreviewButton } from '@Atoms/Buttons';

import './OrgListName.scss';

interface OrganisationListNameProps {
    data: OrganisationOutput;
    path: PatternType;
    onPreviewClick: () => void;
}

const OrganisationListName = ({ data, path, onPreviewClick }: OrganisationListNameProps): ReactElement => {
    const i = useLocalMessage();

    const { name = '', links = [], avatar = '' } = data;

    const orgLetter = name.charAt(0)?.toLocaleUpperCase() || '?';

    return (
        <div className="org-list-name">
            <Avatar src={avatar}>{orgLetter}</Avatar>

            <div className="org-list-name__content">
                <div className="org-list-name__title">
                    <Link to={RouteBuilder.compute(path, { orgId: encodeURI(name) })}>
                        <span className="org-list-name__title-label">{name}</span>
                    </Link>
                </div>

                <p className="org-list-name__linked">
                    {i('organisation.list.table.name.linked-organisations')}

                    {links.length ? (
                        links.map(
                            ({ toOrganisation, linkType }) => (
                                <THTag
                                    className="org-list-name__linked-item"
                                    key={`${toOrganisation}-${linkType}`}
                                    value={`${toOrganisation} (${linkType})`}
                                />
                            ),
                            [],
                        )
                    ) : (
                        <span>{i('general.none')}</span>
                    )}
                </p>

                <div className="generic-drawer-preview">
                    <PreviewButton onClick={onPreviewClick} />
                </div>
            </div>
        </div>
    );
};

export default OrganisationListName;
